// frontend/src/page/registrationSuccess.js
import React from 'react';
import RegSuccess from "../components/reg-success/RegSuccess";

const RegistrationSuccess = () => {
  return (
    <div>
      <RegSuccess/>
    </div>
  );
};

export default RegistrationSuccess;
